import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconCar10: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCar10"><Path d="M4.25 17.5H1.5V4.5H13V6.5H19L22.5 12V17.5H19.75" stroke="currentColor" strokeLinecap="round"/><Path d="M13 6.5V17" stroke="currentColor" strokeLinecap="round"/><Circle cx="7" cy="17" r="2.5" stroke="currentColor" strokeLinecap="round"/><Circle cx="17" cy="17" r="2.5" stroke="currentColor" strokeLinecap="round"/><Path d="M9.75 17.5H14.25" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCar10;
